module.exports = __webpack_public_path__ + "static/media/freddie_mercury_splendid_things.e088b15b.svg";